import type {BdCondition} from '../conditions/condition';
import {BdConjunctionCondition} from './conjunction-condition';

export const BD_OR_CONDITION_ID = 'or';

export class BdOrCondition extends BdConjunctionCondition {

    constructor(
        conditions: BdCondition[] = []
    ) {
        super(BD_OR_CONDITION_ID, conditions);
    }
}
